import { LoaderCircle } from "lucide-react";
import type { ReactNode } from "react";
import { cn } from "./cn.ts";

interface SpinnerProps {
  /** Announced to screen readers; without it the spinner is decorative. */
  label?: string;
  className?: string;
}

export const Spinner = ({ label, className }: SpinnerProps): ReactNode => (
  <span role={label ? "status" : undefined} className={cn("inline-flex items-center", className)}>
    <LoaderCircle aria-hidden="true" className="size-5 animate-spin" />
    {label && <span className="sr-only">{label}</span>}
  </span>
);

export const PageLoading = ({ label }: { label: string }): ReactNode => (
  <div
    role="status"
    className="flex min-h-[40vh] flex-col items-center justify-center gap-3 text-muted-foreground">
    <LoaderCircle aria-hidden="true" className="size-8 animate-spin text-primary" />
    <span>{label}</span>
  </div>
);
